import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalServiceProvider } from '../../../providers';

/*
  Generated class for the NewDashboardServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class NewDashboardServiceProvider {
  bssURL: String = this.globalServiceProvider.appConfig.bss_api;
  constructor(public http: HttpClient, private globalServiceProvider: GlobalServiceProvider) {
    console.log('Hello NewDashboardServiceProvider Provider');
  }
  getBillinggroups(filter: any, condition: any) {
    return this.http.get<any[]>(`${this.bssURL}/billinggroups`, { params: { filter: JSON.stringify(filter), condition: JSON.stringify(condition) } });
  }

  getNewDashboard(filter: any, condition: any) {
    return this.http.get<any[]>(`${this.bssURL}/billinggroups/dailyjobs`, { params: { filter: JSON.stringify(filter), condition: JSON.stringify(condition) } });
  }

  getHistoryJobs(filter: any, condition: any) {
    return this.http.get<any[]>(`${this.bssURL}/billinggroups/historyjobs`, { params: { filter: JSON.stringify(filter), condition: JSON.stringify(condition) } });
  }

  getUnallocatedJobs(filter: any, condition: any) {
    return this.http.get<any[]>(`${this.bssURL}/unallocated/jobs`, { params: { filter: JSON.stringify(filter), condition: JSON.stringify(condition) } });
  }

  async getDVSR(data: any) {
    return new Promise<any[]>((resolve: any, reject: any) => {
      this.http.put<any[]>(`${this.bssURL}/v2/customerfaultdvsr`, data).subscribe((result: any) => {
        // console.log('result: ', result)
        resolve(result);
      }, () => {
        resolve();
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/M2XV2/new-dashboard/new-dashboard-service.ts